import { API_URL } from 'utils/constants/app';
import { RequestHelper } from 'utils/helpers/RequestHelper';

const noteServiceUrl = `${API_URL}/notes`;

const addProductTestLaboDetailsNote = (productTestLaboDetailsId, note) => RequestHelper.POST(
  `${noteServiceUrl}/productTest/${productTestLaboDetailsId}`, note);

const readProducTestNote = (noteId) => RequestHelper.POST(`${noteServiceUrl}/read/${noteId}`);

const deleteNote = (noteId) => RequestHelper.GET(`${noteServiceUrl}/delete/${noteId}`);

export const NoteService = {
  addProductTestLaboDetailsNote,
  deleteNote,
  readProducTestNote
};